import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Button,
  FormControl
} from "react-bootstrap";

import { connect } from "react-redux";

import Nav from "../assets/navBar";
import { getUserData } from "../redux/actions/user";
import { getCitys, sendCity, removeCity } from "../redux/actions/cidades";
class Home extends Component {
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = {
      newCity: ""
    };
  }
  componentDidMount() {
    this.props.getUserData();
    this.props.getCitys();
  }
  render() {
    return (
      <Row className="show-grid">
        <Col xs={1} md={1}>
          <Nav />
        </Col>
        <Col xs={11} md={11} />
        <div className={css(styles.listCity)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.h2)}>Lista de Cidades</h2>
            <div className={css(styles.newCity)}>
              <FormControl
                type="text"
                name="newCity"
                value={this.state.newCity}
                placeholder="Digite um nome de cidade"
                onChange={e => this.setState({ newCity: e.target.value })}
              />
              <Button
                bsStyle="success"
                onClick={() => this.props.sendCity(this.state.newCity)}
              >
                Adicionar cidade
              </Button>
            </div>
          </div>
          <div className={css(styles.blockList)}>
            <ListGroup>
              {this.props.lista.map(e => {
                return (
                  <ListGroupItem key={e.id}>
                    {e.nome}{" "}
                    <button
                      className={css(styles.dell)}
                      onClick={() => this.props.removeCity(e.id)}
                    >
                      x
                    </button>
                  </ListGroupItem>
                );
              })}
            </ListGroup>
          </div>
        </div>
      </Row>
    );
  }
}
const styles = StyleSheet.create({
  listCity: {
    width: "85%",
    marginLeft: "150px"
  },
  blockList: {
    width: "100%",
    maxHeight: "550px",
    overflow: "auto"
  },
  h2: {
    marginRight: "50px",
    color: "#707070",
    fontSize: "2.2rem"
  },
  header: {
    width: "100%",
    height: "60px",
    marginTop: "20px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  dell: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: "none",
    background: "#707070",
    color: "#fff",
    padding: "0px",
    textAlign: "center"
  },
  newCity: {
    width: "40%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  }
});

const mapStateToProps = state => {
  return {
    lista: state.cidades.listCidades
  };
};
export default connect(
  mapStateToProps,
  { getUserData, getCitys, sendCity, removeCity }
)(Home);



// WEBPACK FOOTER //
// ./src/cenas/addCity.js